import { Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core';

enum Language {
  English = 'English',
  German = 'Deutsch',
}

@Component({
  selector: 'lib-language-header',
  templateUrl: 'language-header.component.html',
  styleUrls: ['language-header.component.scss'],
})
export class LanguageHeaderComponent implements OnInit {
  @Input() header = '';
  languages = [
    { name: Language.English, icon: 'assets/english.svg' },
    { name: Language.German, icon: 'assets/german.svg' },
  ];
  selectedLanguage: Language | undefined;

  constructor(@Inject(LOCALE_ID) public locale: string) {
  }

  private static getLanguageIndexAndSubFolder(): { languageIndex: number; subFolder: string; url: string } {
    const path = window.location.pathname.split('/');
    let languageIndex = path.findIndex((element) => element === 'en-US');
    if (languageIndex < 0) {
      languageIndex = path.findIndex((element) => element === 'de');
    }
    const subFolder = languageIndex >= 0 ? path[languageIndex - 1] : '';
    const url = path.slice(languageIndex + 1).join('/');
    return { languageIndex, subFolder, url };
  }

  ngOnInit(): void {
    this.selectedLanguage = this.locale === 'en-US' ? Language.English : Language.German;
  }

  changeLanguage(): void {
    let newLocale;
    switch (this.selectedLanguage) {
      case Language.English:
        newLocale = 'en-US';
        break;
      case Language.German:
        newLocale = 'de';
        break;
    }
    const languageIndexAndSubFolder = LanguageHeaderComponent.getLanguageIndexAndSubFolder();
    window.location.pathname = languageIndexAndSubFolder.subFolder
      ? `/${languageIndexAndSubFolder.subFolder}/${newLocale}/${languageIndexAndSubFolder.url}`
      : `/${newLocale}/${languageIndexAndSubFolder.url}`;
  }
}
